import LeadingLinks from '../../components/leading-links';
import AsideNavLink from '../../components/aside-nav-link';
import AsideLayout from '../../components/layouts/aside-layout';
import MainLayout from '../../components/layouts/main-layout';
import AsxAnnouncementsArchive from '../../components/asx/asx-announcements-archive';
import HeroImage from '../../public/img/hero/company_announcements_1920_640.jpg';
import Head from 'next/head';

export default function CompanyAnnouncements() {
    return (
        <MainLayout>
            <Head>
                <title>Company Announcements | Solvar</title>
                <meta name="description" content="Solvar company Announcements. Latest announcements to the ASX from Solvar. SVR ASX"></meta>
            </Head>
            <AsideLayout
                prev={
                    <LeadingLinks href="/investors/shareholder-information" prev>Shareholder Information</LeadingLinks>
                }
                next={
                    <LeadingLinks href="/investors/annual-reports" next>Annual Reports</LeadingLinks>
                }
                heroImage={ HeroImage }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">Investors</span> › Annual Reports
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history">History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors">Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance">Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy">Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability">Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements" active={true}>Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports">Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us">Contact Us</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">Company Announcements</h1>
                <AsxAnnouncementsArchive startYear="2017" />
            </AsideLayout>
        </MainLayout>
    );
}